import { combineReducers } from 'redux';
import test from 'client/redux/eatd/testReducer';
import options from 'client/redux/eatd/optionsReducer';

export default combineReducers({
  test,
  options,
});
